// extracted by mini-css-extract-plugin
module.exports = {"challeng_box":"challeng_box___3L07J","cycle_item":"cycle_item___8cNCl","body_text":"body_text___w63G5","home_img_1":"home_img_1___1OfbO"};